module.exports = __webpack_public_path__ + "img/b_Rentrit_3.cf290c3a.jpeg";